import { render, staticRenderFns } from "./SupplierReceivable.vue?vue&type=template&id=720b7dd4&"
import script from "./SupplierReceivable.vue?vue&type=script&lang=js&"
export * from "./SupplierReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports